import { Link } from "react-router-dom";
import star from "../../assets/icons/white-star.png";
import TextBox from "./TextBox"; // اگر استفاده نشده می‌توانید پاک کنید
import { act, useState } from "react";
import locationIcon from "../../assets/icons/location-pin.png";
import likeIcon from "../../assets/icons/like.png";
import commentIcon from "../../assets/icons/comments.png";

const FilteredDoctorCard = ({
  id,
  onClick,
  image,
  score,
  name,
  title,
  consultations,
  activityStatus,
  serviceList,
  address,
  freeFirstTime,
}) => {
  return (
    <div
      className="relative flex flex-col w-full gap-7 py-5 px-5 bg-white rounded-[10px]"
    >
      {/* بخش بالایی: عکس، مشخصات و امتیاز */}
      <div className="w-full flex flex-col lg:flex-row justify-between items-center lg:items-start gap-5">
        
        {/* اطلاعات پزشک (عکس + متن) */}
        <div className="flex flex-col lg:flex-row gap-5 items-center lg:items-start w-full lg:w-auto">
          
          {/* کانتینر عکس */}
          <div className="relative w-[80px] h-[80px] shrink-0 mt-2 lg:mt-0">
            <img
              src={image}
              className="w-[80px] h-[80px] object-cover object-top rounded-[50%]"
              alt={name}
            />
            {/* دایره وضعیت */}
            <span
              className={`absolute w-[14px] h-[14px] border-[2px] border-white 
              ${activityStatus === "active" ? "bg-[#0DCB2D]" : "bg-gray-400"}
              rounded-full bottom-1 -right-1`}
            ></span>
          </div>

          {/* داده‌ها و متن‌ها */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-right text-[17px]">
            <h4 className="font-medium sm:text-[20px]">{name}</h4>
            <p className="text-[16px] text-black/70 mt-1">{title}</p>

            {/* کانتینر نظرات */}
            <p className="flex gap-1 items-center justify-center lg:justify-start mt-3">
              <img src={commentIcon} className="w-4 object-contain" alt="comments" />
              <span>{consultations}</span>
              <span className="text-sm text-black/55">دیدگاه کاربران</span>
            </p>

            {/* کانتینر نوبت‌ها */}
            <p className="flex gap-1 items-center justify-center lg:justify-start mt-1">
              <img src={likeIcon} className="w-4 object-contain" alt="likes" />
              <span>{consultations}</span>
              <span className="text-sm text-black/55">نوبت موفق در مدیزن</span>
            </p>
          </div>
        </div>

        {/* امتیاز (ستاره) */}
        <span
          className="absolute top-5 left-5 lg:static flex items-center px-2
          justify-center h-[26px] max-h-[30px] xl:max-h-[40px] w-[50px]
          rounded-[50px] text-white bg-[#FFBB00] shrink-0 gap-1"
        >
          <span className="text-sm pt-0.5">{score}</span>
          <img src={star} className="w-[14px] object-contain" alt="star" />
        </span>
      </div>

      {/* خط آدرس و زمان نوبت */}
      <div className="w-full flex flex-col justify-between 
      items-start gap-3 md:gap-4 border-t pt-7 text-[13px] lg:text-[15px]">
        <div className="flex gap-1  text-right">
          <img src={locationIcon} className="w-4 object-contain" alt="location" />
          <p className="opacity-80 line-clamp-1">{address}</p>
        </div>
        <div className="flex gap-1 text-right">
          <p className="opacity-60">اولین نوبت آزاد مشاوره آنلاین:</p>
          <p>{freeFirstTime}</p>
        </div>
      </div>

      {/* دکمه‌ها */}
      <div className="flex flex-col sm:flex-row w-full gap-3">
        <div className="flex flex-row sm:flex-row sm:w-3/5 gap-2">
          <Link
            to={`/doctor/${id}`}
            className="bg-[#d5d5d5] w-full rounded-[10px] 
            text-[12px] md:text-[14px] text-center h-[36px] sm:h-[48px] flex items-center 
            justify-center hover:bg-gray-300 transition-all disabled:opacity-30"
          >
            نوبت حضوری
          </Link>
          <button
            disabled
            className="bg-[#D5D5D5] w-full rounded-[10px] 
            text-[12px] md:text-[14px] text-center h-[36px] sm:h-[48px] flex items-center 
            justify-center disabled:opacity-30"
          >
            مشاوره متنی
          </button>
          <button
            disabled
            className="bg-[#d5d5d5] w-full rounded-[10px] 
            text-center text-[12px] md:text-[14px] h-[36px] sm:h-[48px] flex items-center 
            justify-center hover:bg-gray-300 transition-all disabled:opacity-30"
          >
            مشاوره تلفنی
          </button>
        </div>

        {/* لینک به صفحه جزئیات پزشک */}
        <Link
          to={`/doctor/${id}`}
          className="sm:w-2/5 bg-aqua text-white transition-all rounded-[10px]
          text-center h-[42px] sm:h-[48px] flex items-center justify-center 
          font-medium text-[14.5px] lg:text-[16.5px]
          hover:bg-[#4CBDB9]"
        >
          دریافت نوبت
        </Link>
      </div>
    </div>
  );
};

export default FilteredDoctorCard;
